// Centralised Italian language file for UI text in Weather App
// Please keep keys in sync with en.ts for consistency

const it = {
  app: {
    title: 'WeatherUp!',
    welcome: 'Benvenuto su WeatherUp! 🌤️',
    subtitle: 'Meteo Mondiale',
    instructions: 'Inserisci il nome di una città per controllare il meteo e rimanere informato sulle condizioni attuali. Inizia digitando nella casella di ricerca qui sopra. Buona esplorazione!'
  },
  weather: {
    loading: 'Caricamento dati meteo...',
    cardTitle: 'Meteo per',
    currentTemp: 'Temperatura Attuale',
    min: 'Min:',
    max: 'Max:',
    localTime: 'Ora Locale',
    details: 'Dettagli Meteo',
    humidity: 'Umidità',
    pressure: 'Pressione',
    windSpeed: 'Velocità del vento',
    visibility: 'Visibilità',
    feelsLike: 'Percepita',
  },
  search: {
    placeholder: 'Cerca una città...',
    ariaLabel: 'Cerca una città',
    button: 'Cerca',
    noResults: 'Nessuna località trovata.'
  }
};

export default it;
